module.exports = __webpack_public_path__ + "static/media/JustActMailers_country.32deef9b.png";